import React, { useContext } from 'react';
import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import 'bulma/css/bulma.min.css';

import { ScanTypeSlug, ScanType } from '../scanTypes.ts'

import { BeamlineContext } from '../beamlineProvider.tsx'
import { InputAutocomplete, SearchFunctions, SearchResult, SelectingStatus } from './inputAutocomplete.tsx'
import { highlightSearchTermsInString } from "../utils.tsx";
import './scanTypeAutocomplete.css';


interface ScanTypeSearchFunctions {
  itemSelected: (item: ScanType) => SelectingStatus;
  selectedNone: () => SelectingStatus;
}


// Settings passed in with the React component
interface ScanTypeAutocompleteParameters {
  selectedItem: ScanType | null;
  searchFunctions: ScanTypeSearchFunctions;
  allowedScanTypes?: ScanTypeSlug[];
  inputSize?: string;
  iconSize?: SizeProp;
  isReadOnly?: boolean;
  greenWhenValid?: boolean;
  triggerFocus?: boolean;
  resetOnDefocus?: boolean;
}


function ScanTypeAutocomplete(settings:ScanTypeAutocompleteParameters) {

  const beamlineContext = useContext(BeamlineContext);

  async function searchScanTypes(searchString: string): Promise<SearchResult<ScanType>> {
    const searchStringLower = searchString.toLowerCase();
    // If allowedScanTypes is an array, we use it even if it's empty.
    const slugsToTest = Array.isArray(settings.allowedScanTypes) ? settings.allowedScanTypes : beamlineContext.scanTypes.typeSlugsInDisplayOrder;
    const toTest = slugsToTest.map((t) => beamlineContext.scanTypes.typesBySlug.get(t)!);
    const matches = toTest.filter((s) =>
                      s.name.toLowerCase().includes(searchStringLower) ||
                      s.description.toLowerCase().includes(searchStringLower));
    return { matches: matches };
  };

  function renderMatch(item: ScanType, searchString: string): React.JSX.Element {
    return (<>
              <td>{ highlightSearchTermsInString(item.name, [searchString]) }</td>
              <td>{ highlightSearchTermsInString(item.description, [searchString]) }</td>
            </>);
  }

  const scanTypeSearchFunctions: SearchFunctions<ScanType> = {
    itemToString: (item) => { return item.name },
    itemsRetriever: searchScanTypes,
    itemSelected: settings.searchFunctions.itemSelected,
    selectedNone: settings.searchFunctions.selectedNone,
    renderMatchedItem: renderMatch
  };

  return InputAutocomplete<ScanType>({
      value: settings.selectedItem ? settings.selectedItem.name : "",
      selectedItem: settings.selectedItem,
      searchFunctions: scanTypeSearchFunctions,
      addedClass: "scantype",
      inputSize: settings.inputSize,
      iconSize: settings.iconSize,
      placeholder: "Select a Scan Type",
      isReadOnly: settings.isReadOnly,
      greenWhenValid: settings.greenWhenValid,
      resetOnDefocus: settings.resetOnDefocus,
      triggerFocus: settings.triggerFocus,
      showAllByDefault: true,
      renderResultsAsTable: true
    });
}

export { ScanTypeAutocomplete }
export type { ScanTypeSearchFunctions }
